export default "__VITE_ASSET__DLx06FFA__"